import React, { useState, useRef } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext"; 
import Header from "../../Common/Layout/Header"; 
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import FlightTabs from "../AllTabs/FlightTabs";

const ManualVoucherGenerator = () => {
  const { user } = useAuth(); 
  const contentRef = useRef();

  // --- State for Form Data ---
  const [formData, setFormData] = useState({
    airlinePnr: "85FDZL", 
    segments: [
      {
        airline: "Air India",
        flightNo: "AI - 2559",
        fareType: "ECO VALUE", 
        depCity: "Hyderabad",
        depAirport: "Rajiv Gandhi International",
        depCode: "HYD",
        depTime: "2026-02-09T06:30", 
        arrCity: "New Delhi",
        arrAirport: "Indira Gandhi Airport",
        arrCode: "DEL",
        arrTime: "2026-02-09T08:45", 
        duration: "2h 15m", 
        cabin: "Economy"
      },
    ],
    // Passengers
    passengers: [{ title: "Mr", firstName: "", lastName: "", type: "Adult", ticketNo: "", seat: "10F", meal: "Veg", baggage: "15kg / 7kg" }],
  });

  // --- Handlers ---
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSegmentChange = (index, e) => {
    const { name, value } = e.target;
    const newSegments = [...formData.segments];
    newSegments[index][name] = value;
    setFormData({ ...formData, segments: newSegments });
  };

  const addSegment = () => {
    setFormData({
      ...formData,
      segments: [...formData.segments, { airline: "", flightNo: "", fareType: "", depCity: "", depAirport: "", depCode: "", depTime: "", arrCity: "", arrAirport: "", arrCode: "", arrTime: "", duration: "", cabin: "Economy" }],
    });
  };

  const removeSegment = (index) => {
    const newSegments = formData.segments.filter((_, i) => i !== index);
    setFormData({ ...formData, segments: newSegments });
  };

  const handlePassengerChange = (index, e) => {
    const { name, value } = e.target;
    const newPassengers = [...formData.passengers];
    newPassengers[index][name] = value;
    setFormData({ ...formData, passengers: newPassengers });
  };

  const addPassenger = () => {
    setFormData({
      ...formData,
      passengers: [...formData.passengers, { title: "Mr", firstName: "", lastName: "", type: "Adult", ticketNo: "", seat: "", meal: "", baggage: "" }],
    });
  };

  const removePassenger = (index) => {
    const newPassengers = formData.passengers.filter((_, i) => i !== index);
    setFormData({ ...formData, passengers: newPassengers });
  };

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
  });

  const handlePDF = () => {
    const input = contentRef.current;
    html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("Ticket_Voucher.pdf");
    });
  };

  // Helper styles 
  const styles = {
      container: { fontFamily: 'Arial, sans-serif', color: '#000', padding: '30px', backgroundColor: '#fff' },
      headerLine: { borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
      routeHeader: { borderBottom: '1px solid #000', paddingBottom: '5px', marginBottom: '15px', fontSize: '18px', fontWeight: 'bold' },
      flightRow: { display: 'flex', marginBottom: '20px' },
      colAirline: { width: '20%' },
      colDep: { width: '25%' },
      colDur: { width: '15%', textAlign: 'center', fontSize: '11px', color: '#666' },
      colArr: { width: '40%' },
      timeText: { fontSize: '22px', fontWeight: 'bold' },
      dateText: { fontSize: '12px', color: '#333' },
      airportText: { fontSize: '12px', color: '#666', lineHeight: '1.2' },
      tableHeader: { borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc', padding: '8px 0', fontSize: '11px', fontWeight: 'bold', color: '#333', textTransform: 'uppercase' },
      tableRow: { padding: '10px 0', borderBottom: '1px solid #eee', fontSize: '12px' }
  };

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection="flights"/>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="p-2">
                              <FlightTabs pageName="VOUCHERGENERATOR" />
                            </div>
            {/* Top Bar */}
            <div className="row mb-3">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">Manual Voucher Generator</h4>
                    <div>
                        <button className="btn btn-info text-white me-2 shadow-none" onClick={handlePrint}>
                             <i className="ri-printer-line me-1"></i> Print
                        </button>
                        <button className="btn btn-primary shadow-none" onClick={handlePDF}>
                             <i className="ri-file-download-line me-1"></i> Download PDF
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
              {/* --- LEFT COLUMN: INPUT FORM --- */}
              <div className="col-lg-5">
                <div className="card shadow-sm" style={{height: '85vh', overflowY: 'auto', backgroundColor: '#f1f5f7'}}>
                    <div className="card-body">
                        
                        <h6 className="text-primary fw-bold">General Info</h6>
                        <div className="row g-2 mb-3">
                            
                            <div className="col-6">
                                <label className="form-label small mb-1">Airline PNR (Global)</label>
                                <input className="form-control form-control-sm" name="airlinePnr" value={formData.airlinePnr} onChange={handleInputChange} />
                            </div>
                        </div>

                        {/* Segments Accordion */}
                        <h6 className="text-primary fw-bold mt-4 border-bottom pb-2">Flight Details</h6>
                        {formData.segments.map((seg, index) => (
                            <div key={index} className="bg-white p-3 rounded shadow-sm mb-3">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="fw-bold small text-muted">SEGMENT {index + 1}</span>
                                    {index > 0 && <button className="btn btn-sm text-danger" onClick={()=>removeSegment(index)}>Remove</button>}
                                </div>
                                <div className="row g-2">
                                    <div className="col-6"><input className="form-control form-control-sm" name="airline" placeholder="Airline (Air India)" value={seg.airline} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" name="flightNo" placeholder="Flt No (AI - 2559)" value={seg.flightNo} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" name="fareType" placeholder="Fare Type (ECO VALUE)" value={seg.fareType} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" name="cabin" placeholder="Cabin (Economy)" value={seg.cabin} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    
                                    <div className="col-12 mt-2 border-top pt-2"><small className="text-muted fw-bold">DEPARTURE</small></div>
                                    <div className="col-4"><input className="form-control form-control-sm" name="depCode" placeholder="Code (HYD)" value={seg.depCode} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-8"><input type="datetime-local" className="form-control form-control-sm" name="depTime" value={seg.depTime} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" name="depCity" placeholder="City (Hyderabad)" value={seg.depCity} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" name="depAirport" placeholder="Airport Name" value={seg.depAirport} onChange={(e)=>handleSegmentChange(index, e)} /></div>

                                    <div className="col-12 mt-2 border-top pt-2"><small className="text-muted fw-bold">ARRIVAL</small></div>
                                    <div className="col-4"><input className="form-control form-control-sm" name="arrCode" placeholder="Code (DEL)" value={seg.arrCode} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-8"><input type="datetime-local" className="form-control form-control-sm" name="arrTime" value={seg.arrTime} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" name="arrCity" placeholder="City (New Delhi)" value={seg.arrCity} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" name="arrAirport" placeholder="Airport Name" value={seg.arrAirport} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                    
                                    <div className="col-12 mt-2"><input className="form-control form-control-sm" name="duration" placeholder="Duration (2h 15m)" value={seg.duration} onChange={(e)=>handleSegmentChange(index, e)} /></div>
                                </div>
                            </div>
                        ))}
                        <button className="btn btn-sm btn-soft-primary w-100 mb-3" onClick={addSegment}>+ Add Another Flight</button>

                        {/* Passengers */}
                        <h6 className="text-primary fw-bold mt-4 border-bottom pb-2">Travellers</h6>
                        {formData.passengers.map((pax, index) => (
                            <div key={index} className="bg-white p-3 rounded shadow-sm mb-3">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="fw-bold small text-muted">PASSENGER {index + 1}</span>
                                    {index > 0 && <button className="btn btn-sm text-danger" onClick={()=>removePassenger(index)}>Remove</button>}
                                </div>
                                <div className="row g-2">
                                    <div className="col-3">
                                        <select className="form-control form-control-sm" name="title" value={pax.title} onChange={(e)=>handlePassengerChange(index, e)}>
                                            <option>Mr</option><option>Ms</option><option>Mrs</option>
                                        </select>
                                    </div>
                                    <div className="col-5">
                                        <input className="form-control form-control-sm" name="firstName" placeholder="First Name" value={pax.firstName} onChange={(e)=>handlePassengerChange(index, e)} />
                                    </div>
                                    <div className="col-4">
                                        <input className="form-control form-control-sm" name="lastName" placeholder="Last Name" value={pax.lastName} onChange={(e)=>handlePassengerChange(index, e)} />
                                    </div>
                                    <div className="col-6"><input className="form-control form-control-sm" name="ticketNo" placeholder="Ticket No" value={pax.ticketNo} onChange={(e)=>handlePassengerChange(index, e)} /></div>
                                    <div className="col-3"><input className="form-control form-control-sm" name="seat" placeholder="Seat" value={pax.seat} onChange={(e)=>handlePassengerChange(index, e)} /></div>
                                    <div className="col-3"><input className="form-control form-control-sm" name="meal" placeholder="Meal" value={pax.meal} onChange={(e)=>handlePassengerChange(index, e)} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" name="baggage" placeholder="Baggage (e.g. 15kg)" value={pax.baggage} onChange={(e)=>handlePassengerChange(index, e)} /></div>
                                </div>
                            </div>
                        ))}
                        <button className="btn btn-sm btn-soft-primary w-100 mb-3" onClick={addPassenger}>+ Add Passenger</button>

                    </div>
                </div>
              </div>

              {/* --- RIGHT COLUMN: EXACT DESIGN PREVIEW --- */}
              <div className="col-lg-7">
                <div className="card shadow-lg border-0">
                    <div className="card-body p-0">
                        {/* THE PREVIEW CANVAS */}
                        <div ref={contentRef} style={{...styles.container, minHeight: '900px'}}>
                            
                            {/* 1. Header Line */}
                            <div style={styles.headerLine}>
                                <div style={{display:'flex', alignItems:'center'}}>
                                    <span style={{fontFamily: 'serif', fontWeight: 'bold', fontSize: '28px', marginRight:'10px'}}>ticket</span>
                                   
                                </div>
                                <div>
                                    {/* 1. REPLACED LOGO WITH TEXT MYFIRSTBOOKING */}
                                    <h4 className="m-0 fw-bold" style={{fontSize: '20px'}}>MYFIRSTBOOKING</h4>
                                </div>
                            </div>

                            {/* 2. Loop through Segments */}
                            {formData.segments.map((seg, i) => (
                                <div key={i}>
                                    {/* Route Header */}
                                    <div style={styles.routeHeader}>
                                        {seg.depCity} to {seg.arrCity} 
                                        <span style={{fontWeight: 'normal', fontSize: '14px', float: 'right', marginTop:'4px'}}>
                                            {seg.depTime ? moment(seg.depTime).format("ddd, DD MMM YYYY") : ""}
                                        </span>
                                    </div>

                                    {/* Flight Details Row */}
                                    <div style={styles.flightRow}>
                                        <div style={styles.colAirline}>
                                            <div style={{fontWeight: 'bold', fontSize:'14px'}}>{seg.airline}</div>
                                            <div style={{fontSize: '12px', color:'#333', marginBottom:'5px'}}>{seg.flightNo}</div>
                                            <div style={{fontSize: '12px', color:'#666'}}>Fare type: {seg.fareType}</div>
                                        </div>

                                        <div style={styles.colDep}>
                                            <div style={{display:'flex', alignItems:'center'}}>
                                                <span style={{fontSize:'16px', color:'#666', marginRight:'5px'}}>{seg.depCode}</span>
                                                <span style={styles.timeText}>{seg.depTime ? moment(seg.depTime).format("HH:mm") : "--:--"}</span>
                                            </div>
                                            <div style={styles.dateText}>{seg.depTime ? moment(seg.depTime).format("ddd, DD MMM YYYY") : ""}</div>
                                            <div style={styles.airportText}>
                                                {seg.depCity} - {seg.depAirport}
                                            </div>
                                        </div>

                                        <div style={styles.colDur}>
                                            <div style={{marginBottom:'2px'}}>🕒</div>
                                            <div style={{fontWeight:'bold', color:'#333'}}>{seg.duration}</div>
                                            <div>{seg.cabin}</div>
                                        </div>

                                        <div style={styles.colArr}>
                                            <div style={{display:'flex', alignItems:'center'}}>
                                                <span style={styles.timeText}>{seg.arrTime ? moment(seg.arrTime).format("HH:mm") : "--:--"}</span>
                                                <span style={{fontSize:'16px', color:'#666', marginLeft:'5px'}}>{seg.arrCode}</span>
                                            </div>
                                            <div style={styles.dateText}>{seg.arrTime ? moment(seg.arrTime).format("ddd, DD MMM YYYY") : ""}</div>
                                            <div style={styles.airportText}>
                                                {seg.arrCity} - {seg.arrAirport}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* 3. Extra Info */}
                            <div style={{fontSize: '11px', marginBottom: '20px', lineHeight: '1.6'}}>
                                <div>Baggage (per Adult/Child) - Check-in: <strong>{formData.passengers[0]?.baggage || "15kg"}</strong></div>
                                <div>Meals booked - <strong>{formData.passengers[0]?.meal || "N/A"}</strong></div>
                                <div>Seats - <strong>{formData.passengers[0]?.seat || "Any"}</strong></div>
                                <div style={{marginTop: '5px'}}>Your selected seat and meal options have been successfully confirmed.</div>
                            </div>

                            {/* 4. Travellers Table - ADDED AIRLINE PNR COLUMN */}
                            <div style={styles.tableHeader}>
                                <div className="row m-0">
                                    <div className="col-4 p-0">TRAVELLERS</div>
                                    <div className="col-4 p-0 text-center">AIRLINE PNR</div>
                                    <div className="col-4 p-0 text-end">TICKET NO.</div>
                                </div>
                            </div>
                            {formData.passengers.map((pax, i) => (
                                <div key={i} style={styles.tableRow}>
                                    <div className="row m-0 align-items-center">
                                        <div className="col-4 p-0 fw-bold">
                                            <i className="ri-user-fill me-1"></i> {pax.title} {pax.firstName} {pax.lastName}
                                        </div>
                                        <div className="col-4 p-0 text-center fw-bold">
                                            {/* DISPLAYING AIRLINE PNR HERE */}
                                            {formData.airlinePnr || "---"}
                                        </div>
                                        <div className="col-4 p-0 text-end">
                                            {pax.ticketNo || "Pending"}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* 5. About This Trip (EXACT TEXT COPY) */}
                            <div style={{marginTop: '25px', borderTop: '2px solid #000', paddingTop: '10px'}}>
                                <div style={{fontSize: '11px', fontWeight: 'bold', marginBottom: '5px'}}>
                                    TIP: Write your child's name and your hotel number on each card; include a close friend's or relative's contact information on the card. Give a card to each child which they will carry with them as long as you are away.
                                </div>
                                <div style={{fontSize: '11px', fontWeight: 'bold', marginBottom: '5px'}}>ABOUT THIS TRIP</div>
                                <ul style={{fontSize: '10px', color: '#555', paddingLeft: '15px', lineHeight: '1.4'}}>
                                    <li>Note: Except for medical devices, electronic devices which are larger than a cell phone/smart phone cannot be carried in the cabin of the aircraft.</li>
                                    <li>Note: Only cell phones of dimension Length: 16cm x Width: 9.3cm x Depth: 1.5cm are allowed in the cabin baggage. Please carry all other electronic equipment inside check-in baggage.</li>
                                    <li>Use your Trip ID for all communication with {"MyFirstBooking"} about this booking.</li>
                                    <li>Please reach the airport 3 hours before the departure time. Check-in counters at the airport close 2 hours before departure.</li>
                                    <li>Your carry-on baggage shouldn't weigh more than 7kgs.</li>
                                    <li>Carry photo identification, you will need it as proof of identity while checking-in.</li>
                                    <li>If cancellation or amendment is done, {"MyFirstBooking"} will charge Rs. 400/- per passenger per flight.</li>
                                    <li>Compulsory Guidelines For Safe Travel</li>
                                    <li>Please note as per government regulations, it is mandated to obtain an E-pass to travel to some states in India. Failure to produce the E-pass at the boarding gate may lead to denial of boarding. Please check website for more details and state wise regulations.</li>
                                    <li>For hassle free processing, cancel/amend your tickets with {"MyFirstBooking"} instead of doing so directly with Airline.</li>
                                </ul>
                            </div>

                            {/* 6. Footer (FARE REMOVED) */}
                            <div style={{marginTop: '20px', borderTop:'1px solid #ddd', paddingTop:'15px'}}>
                                <div style={{width: '100%'}}>
                                    <div style={{border: '1px solid #000', padding: '10px', borderRadius:'4px', display:'flex', alignItems:'center'}}>
                                        <div style={{fontSize:'20px', marginRight:'10px'}}>🎧</div>
                                        <div>
                                            <div style={{fontWeight:'bold', fontSize:'12px'}}>Manage bookings online</div>
                                           
                                        </div>
                                    </div>
                                    <div style={{marginTop:'10px', fontSize:'11px', fontWeight:'bold'}}>
                                        {formData.segments[0].airline} helpline: 1860 233 1407 
                                       
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualVoucherGenerator;